import apiService from '@/services/apiService';

const actions = {
  getPaxelcoDashboard({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('marketing/dashboard')
        .then((response) => {
          commit('getPaxelcoDashboard', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postPaxelcoDashboard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/dashboard', payload)
        .then((response) => {
          // commit('postPaxelcoDashboard', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
